import { render, staticRenderFns } from "./TenantUserListScreen.vue?vue&type=template&id=6822169f&scoped=true&lang=pug"
import script from "./TenantUserListScreen.vue?vue&type=script&lang=ts"
export * from "./TenantUserListScreen.vue?vue&type=script&lang=ts"
import style0 from "./TenantUserListScreen.vue?vue&type=style&index=0&id=6822169f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6822169f",
  null
  
)

export default component.exports